
import React from 'react'
import PropTypes from 'prop-types'

import { IconButton, Menu, MenuItem } from '@material-ui/core'
import { saveTXT, saveHTML } from '../../utils'
import { downloadIcon, SvgIcon } from '../../../../components/icons'

import './DownloadChat.scss'

const DownloadChatButton = ({ transcript, messageDisplayAreaRef, texts, accountName }) => {
  function downloadChatInHTML() {
    setAnchorEl(null)
    saveHTML({ transcript, messageDisplayAreaRef })
  }

  function downloadChatInTXT() {
    saveTXT({ transcripts: [transcript], texts, accountName })
  }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = ev => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  return (
    <div className="downloadChatButton roundButton">
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        title={texts['tooltip-export1']}
      >
        <SvgIcon svg={downloadIcon} />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 48 * 4.5,
            width: '20ch',
          },
        }}
      >
        <MenuItem selected={false} onClick={downloadChatInHTML}>HTML</MenuItem>
        <MenuItem selected={false} onClick={downloadChatInTXT}>TXT</MenuItem>
      </Menu>
    </div>
  )
}

DownloadChatButton.propTypes = {
  transcript: PropTypes.object.isRequired,
  messageDisplayAreaRef: PropTypes.object.isRequired,
  texts: PropTypes.object.isRequired,
  accountName: PropTypes.string.isRequired,
};

export default DownloadChatButton
